import React from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from '@/components/Logo';

export default function Privacy() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      padding: '28px 20px 36px',
    }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <BrandMark size={30} />
            <span style={{ fontSize: 15, fontWeight: 600 }}>podnikai.sk</span>
          </div>
          <Link to="/" style={{ fontSize: 12.5, color: 'var(--product-primary-hover)', textDecoration: 'underline' }}>
            Späť
          </Link>
        </div>

        <article style={{
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-xl)',
          padding: '22px 22px 18px',
          lineHeight: 1.6,
        }}>
          <h1 style={{
            margin: '0 0 14px',
            fontSize: 28,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            fontFamily: 'var(--font-display)',
          }}>
            Zásady ochrany osobných údajov
          </h1>

          <Section title="1. Prevádzkovateľ">
            <p>
              Prevádzkovateľom služby podnikai.sk je Daniel Reindl. Pre otázky k ochrane osobných údajov nás kontaktuj na
              {' '}<a href="mailto:hello@studionow.app" style={linkStyle}>hello@studionow.app</a>.
            </p>
          </Section>

          <Section title="2. Účel spracúvania">
            <p>
              Osobné údaje spracúvame na účely fungovania aplikácie: vystavenie faktúr, evidencia výdavkov,
              správa klientov a voliteľná AI extrakcia údajov z dokladov.
            </p>
          </Section>

          <Section title="3. Aké dáta zbierame">
            <p><strong>Povinné pre fungovanie služby:</strong></p>
            <ul>
              <li>Účet používateľa (email, technické identifikátory prihlásenia)</li>
              <li>Firemné údaje, faktúry, klienti, výdavky a nastavenia workspace</li>
              <li>Technické logy potrebné na bezpečnosť a prevádzku</li>
            </ul>
            <p><strong>Voliteľné pri zapnutí anonymného benchmarkingu (opt-in):</strong></p>
            <ul>
              <li>Typ firmy (SZČO / s.r.o.)</li>
              <li>Kategórie výdavkov a používanie funkcií</li>
              <li>Agregované sumy v intervaloch a počty dokladov</li>
            </ul>
          </Section>

          <Section title="4. Subprocessors">
            <ul>
              <li>
                Supabase (EU):{' '}
                <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  supabase.com/privacy
                </a>
              </li>
              <li>
                Cloudflare Worker:{' '}
                <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  cloudflare.com/privacypolicy
                </a>
              </li>
              <li>
                Google AI Studio (Gemini):{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  policies.google.com/privacy
                </a>
              </li>
              <li>
                OpenRouter:{' '}
                <a href="https://openrouter.ai/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  openrouter.ai/privacy
                </a>
              </li>
            </ul>
          </Section>

          <Section title="5. Retention a anonymizácia">
            <p>
              Dáta uchovávame primerane účelu spracúvania. Benchmarkingové analytické dáta uchovávame najviac 24 mesiacov,
              následne prechádzajú anonymizáciou alebo bezpečným odstránením.
            </p>
          </Section>

          <Section title="6. Tvoje práva">
            <p>Máš právo na prístup k údajom, opravu, vymazanie, prenositeľnosť a namietanie spracúvania.</p>
          </Section>

          <Section title="7. Cookies / local storage">
            <p>
              Používame technické úložisko potrebné na fungovanie aplikácie, najmä autentifikačný token a identifikátor
              aktívneho workspace v local storage.
            </p>
          </Section>

          <Section title="8. Kontakt">
            <p>
              V prípade otázok alebo žiadostí nás kontaktuj na{' '}
              <a href="mailto:hello@studionow.app" style={linkStyle}>hello@studionow.app</a>.
            </p>
          </Section>

          <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid var(--border)', fontSize: 12, color: 'var(--text-muted)' }}>
            Posledná aktualizácia: 2026-05-02
          </div>
        </article>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: 14 }}>
      <h2 style={{ margin: '0 0 6px', fontSize: 17, fontWeight: 700 }}>{title}</h2>
      <div style={{ fontSize: 13.5, color: 'var(--text-secondary)' }}>{children}</div>
    </section>
  );
}

const linkStyle = {
  color: 'var(--product-primary-hover)',
  textDecoration: 'underline',
};
